<template>
  <dialog_wheelDateChooser 
    @submit="handleDateSubmit" 
    v-if="datePickerShow" 
    :default-date="tempDateForWheel" 
  />

  <dialog_customerPicker @submit="handleCustomerPickerSubmit" v-if="showCustomerPicker" />
  <dialog_customerTagEdit v-if="tag_edit_show" :tagEditSwitch="tagEditSwitch" :reloadTagList="reloadTagList" />

  <div id="dialog-customerRegister">
    <div class="dialog">
      <span class="cls" @click="closeDialog"></span>

      <div class="paper">
        <div class="header">
          <div class="step-indicator">{{ currentStep }} / {{ totalSteps }}</div>
          <span @click="closeDialog">✕</span>
        </div>

        <swiper
          :modules="modules"
          :slides-per-view="1"
          :space-between="0"
          :allow-touch-move="false"
          @swiper="onSwiper"
          class="register-swiper"
        >
          <!-- 1. 이름 -->
          <swiper-slide>
            <div class="step-content-single">
              <div class="icon"> <img src="/imgs/common/CR_NAM.png"/> </div>
              <h1>고객님 성함을 입력</h1>
              <input 
                type="text" 
                v-model="newCustomer.name" 
                placeholder="예) 홍길동"
                @keyup.enter="nextStep"
                @keydown.tab.prevent="nextStep"
                class="main-input"
                autofocus
              >
              
              <!-- 별칭 추가 영역 -->
              <div class="optional-field">
                <button 
                  v-if="!showNickname" 
                  @click="showNickname = true" 
                  class="toggle-btn"
                >
                  <i class="ph ph-plus"></i> 별칭 추가
                </button>
                <div v-else class="optional-input-wrap">
                  <label>별칭</label>
                  <input 
                    type="text" 
                    v-model="newCustomer.nickname" 
                    placeholder="예) 길동이형, 강남치과원장님"
                    @keyup.enter="nextStep"
                    class="sub-input"
                  >
                </div>
              </div>
              
              <p class="desc">성함을 잘 모르는 경우 임시로 별칭을 입력해주세요</p>
            </div>
          </swiper-slide>

          <!-- 2. 전화번호 -->
          <swiper-slide>
            <div class="step-content-single">
              <div class="icon"> <img src="/imgs/common/CR_PON.png"/></div>
              <h1>연락처</h1>
              <input 
                ref="phoneInput"
                type="tel" 
                v-model="newCustomer.phone" 
                placeholder="-없이 번호만 입력해주세요"
                @keyup.enter="nextStep"
                @keydown.tab.prevent="nextStep"
                @input="formatPhone"
                class="main-input"
              >
              <p class="desc">회원가입 및 수신동의를 하시면 <br> 영업 소식과 특별한 선물을 드립니다.</p>
            </div>
          </swiper-slide>

          <!-- 3. 주민번호 -->
          <swiper-slide>
            <div class="step-content-single">
              <div class="icon"> <img src="/imgs/common/CR_RRN.png"/> </div>
              <h1>생년월일 - 성별</h1>
              
              <div class="double">
                <input 
                  ref="civNumFirstInput"
                  type="text" 
                  v-model="firstCivNum" 
                  placeholder="990101"
                  maxLength="6"
                  @keyup.enter="focusLastCivNum"
                  @keydown.tab.prevent="focusLastCivNum"
                  @input="formatCivNum('first')"
                  class="main-input"
                  style="flex:1"
                >
                <h1>-</h1>
                <input 
                  ref="civNumLastInput"
                  type="password"
                  autocomplete="new-password"
                  v-model="lastCivNum" 
                  placeholder="●"
                  maxLength="1"
                  @keyup.enter="nextStep"
                  @keydown.tab.prevent="nextStep"
                  @input="formatCivNum('last')"
                  style="flex:0.2"
                  class="main-input"
                >
              </div>

              <!-- 실제 생일 추가 영역 -->
              <div class="optional-field">
                <button 
                  v-if="!showRealBirth" 
                  @click="showRealBirth = true" 
                  class="toggle-btn"
                >
                  <i class="ph ph-calendar-plus"></i> 실제 생일이 다른가요?
                </button>
                <div v-else class="optional-input-wrap">
                  <label>실제 생일</label>
                  <input 
                    type="text" 
                    v-model="newCustomer.birth" 
                    placeholder="예) 1999-01-15"
                    maxLength="10"
                    @input="formatBirth"
                    @keyup.enter="nextStep"
                    class="sub-input"
                  >
                  <span class="helper-text">음력생일, 실제생일 등 주민등록과 다른 경우</span>
                </div>
              </div>

              <p class="desc" v-if="!showRealBirth">주민등록상 생년월일을 입력해주세요</p>
            </div>
          </swiper-slide>

          <!-- 4. 주소 -->
          <swiper-slide>
            <div class="step-content-single">
              <div class="icon"> <img src="/imgs/common/CR_ADR.png"/> </div>
              <h1>주소</h1>
              
              <div class="double">
                <input 
                  ref="addressInput"
                  type="text" 
                  v-model="newCustomer.address" 
                  placeholder="예) 서울특별시 강남구"
                  @keyup.enter="nextStep"
                  @keydown.tab.prevent="nextStep"
                  class="main-input"
                >
                <button @click="openDaumPostcode" class="find-btn">찾기</button>
              </div>

              <!-- 상세주소 토글 -->
              <div class="optional-field">
                <button 
                  v-if="!showExAddress" 
                  @click="showExAddress = true" 
                  class="toggle-btn"
                >
                  <i class="ph ph-plus"></i> 상세주소 추가
                </button>
                <div v-else class="optional-input-wrap">
                  <label>상세주소</label>
                  <input 
                    ref="exAddressInput"
                    type="text" 
                    v-model="newCustomer.ex_address" 
                    placeholder="예) 101동 202호"
                    @keyup.enter="nextStep"
                    class="sub-input"
                  >
                </div>
              </div>
              
              <p class="desc">선물을 받을 수 있는 실제 거주지를 입력해주세요</p>
            </div>
          </swiper-slide>

          <!-- 5. 완료 -->
          <swiper-slide>
            <div class="step-content-single completion">
              <div class="icon">
                <img src="/imgs/common/CR_CON.png"/>
              </div>
              <h1>등록 완료!</h1>
              <p class="desc">고객이 등록되었어요 🎉</p>

              <div class="summary">
                <div class="summary-item" v-if="newCustomer.name || newCustomer.nickname">
                  <i class="ph-fill ph-user"></i>
                  <span>{{ newCustomer.name || newCustomer.nickname }}</span>
                </div>
                <div class="summary-item" v-if="newCustomer.phone">
                  <i class="ph-fill ph-phone"></i>
                  <span>{{ newCustomer.phone }}</span>
                </div>
                <div class="summary-item" v-if="firstCivNum && lastCivNum">
                  <i class="ph-fill ph-identification-card"></i>
                  <span>{{ firstCivNum || newCustomer.birth }}-{{ lastCivNum }}******</span>
                </div>
                <div class="summary-item" v-if="newCustomer.address">
                  <i class="ph-fill ph-house"></i>
                  <span>{{ newCustomer.address }} {{ newCustomer.ex_address }}</span>
                </div>
              </div>

              <div class="double">
                <button @click="saveAndEdit" class="action-btn secondary" :disabled="isSaving">
                  <i class="ph-fill ph-plus"></i>
                  추가 정보 입력하기
                </button>
                <button @click="saveAndClose" class="action-btn primary" :disabled="isSaving">
                  <i class="ph-fill ph-check"></i>
                  마침
                </button>
              </div>
            </div>
          </swiper-slide>
        </swiper>

        <div class="nav-buttons">
          <button 
            v-if="currentStep > 1 && currentStep < totalSteps" 
            @click="prevStep" 
            class="nav-btn prev"
          >
            <i class="ph ph-arrow-left"></i>
          </button>
          
          <button 
            v-if="currentStep < totalSteps" 
            @click="handleNext" 
            class="nav-btn next"
            :class="{ primary: currentStep === 1 }"
          >
            <i class="ph ph-arrow-right"></i>
          </button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, ref } from "vue";
import { Swiper, SwiperSlide } from 'swiper/vue';

import dialog_wheelDateChooser from '@/components/dialogs/wheelDateChooser.vue';
import dialog_customerPicker from '@/components/dialogs/customerPicker.vue';
import dialog_customerTagEdit from "@/components/dialogs/customerTagEdit.vue";
import { useBackButton } from '@/utils/useBackBtn';

export default {
  emits: ['submit', 'close', 'openEdit'],
  props: {
    registerDialogSwitch: Function,
    reloadForSync: Function,
  },
  components: {
    Swiper,
    SwiperSlide,
    dialog_wheelDateChooser,
    dialog_customerPicker,
    dialog_customerTagEdit,
  },
  setup(props, { emit }) {
    const sql_query = inject('sql_query');
    const member_info = inject('member_info');
    const checkCustomerMilestone = inject('checkCustomerMilestone');
    
    const swiperInstance = ref(null);
    const currentStep = ref(1);
    const totalSteps = ref(5);
    const modules = [];

    // newCustomer에 필드 추가
    const newCustomer = ref({
      name: '',
      nickname: '',
      phone: '',
      address: '',
      ex_address: '',
      location: '',
      birth: '',
    });

    const firstCivNum = ref('');
    const lastCivNum = ref('');
    const showCustomerPicker = ref(false);
    const datePickerShow = ref(false);
    const tempDateForWheel = ref(null);
    const tag_edit_show = ref(false);
    const showNickname = ref(false);
    const showRealBirth = ref(false);
    const customer = ref(null);
    const isSaving = ref(false);
    const showExAddress = ref(false);

    // refs for focus control
    const civNumLastInput = ref(null);
    const exAddressInput = ref(null);

    function formatPhone() {
      let value = newCustomer.value.phone.replace(/[^0-9]/g, '');
      if (value.length > 11) value = value.slice(0, 11);
      newCustomer.value.phone = value;
    }

    function formatCivNum(type) {
      if (type === 'first') {
        firstCivNum.value = firstCivNum.value.replace(/[^0-9]/g, '');
        if (firstCivNum.value.length > 6) {
          firstCivNum.value = firstCivNum.value.slice(0, 6);
        }
      } else {
        lastCivNum.value = lastCivNum.value.replace(/[^0-9]/g, '');
        if (lastCivNum.value.length > 1) {
          lastCivNum.value = lastCivNum.value.slice(0, 1);
        }
      }
    }

    // 생일 포맷 함수 추가
    function formatBirth() {
      let value = newCustomer.value.birth.replace(/[^0-9]/g, '');
      if (value.length > 8) value = value.slice(0, 8);
      
      // 자동으로 하이픈 추가
      if (value.length >= 5) {
        value = value.slice(0, 4) + '-' + value.slice(4, 6) + (value.length > 6 ? '-' + value.slice(6) : '');
      } else if (value.length >= 4) {
        value = value.slice(0, 4) + '-' + value.slice(4);
      }
      
      newCustomer.value.birth = value;
    }

    // 주민번호 뒷자리로 포커스
    function focusLastCivNum() {
      setTimeout(() => {
        civNumLastInput.value?.focus();
      }, 50);
    }

    // 상세주소로 포커스
    function focusExAddress() {
      setTimeout(() => {
        exAddressInput.value?.focus();
      }, 50);
    }

    useBackButton(() => {
      if (currentStep.value > 1 && currentStep.value < totalSteps.value) {
        prevStep();
      } else {
        closeDialog();
      }
    });

    function onSwiper(swiper) {
      swiperInstance.value = swiper;
    }

    function handleNext() {
      nextStep();
    }

    let doingSwipeNext = false;
    async function nextStep() {
      if (currentStep.value < totalSteps.value && !doingSwipeNext) {
        currentStep.value++;
        await swiperInstance.value?.slideNext();
        doingSwipeNext = true;
        // 다음 슬라이드의 input에 focus
        await setTimeout(() => {
          if (currentStep.value === 2) {
            // 전화번호 입력
            const phoneInput = document.querySelector('input[type="tel"]');
            phoneInput?.focus();
          } else if (currentStep.value === 3) {
            // 주민번호 앞자리 입력
            const civNumInput = document.querySelector('input[placeholder="990101"]');
            civNumInput?.focus();
          } else if (currentStep.value === 4) {
            // 주소 입력
            const addressInput = document.querySelector('input[placeholder="예) 서울특별시 강남구"]');
            addressInput?.focus();
          }
        }, 500); // swiper 전환 애니메이션 후 focus
        doingSwipeNext = false;
      }
    }

    function prevStep() {
      if (currentStep.value > 1) {
        currentStep.value--;
        swiperInstance.value?.slidePrev();
      }
    }

    function escapeStr(value) {
      return value !== null && value !== undefined ? String(value).replace(/'/g, "\\'") : null;
    }

    function sanitizeName(name) {
      if (!name) return '무명';

      const cleaned = name
        .replace(/\s+/g, ' ')      // 연속 공백 제거
        .replace(/[^\p{L}\p{N} ]/gu, '') // 특수문자 제거 (한글/영문/숫자)
        .trim();

      if (cleaned.length < 2) return '무명';
      if (cleaned.length > 10) return cleaned.slice(0, 10);

      return cleaned;
    }

    async function saveCustomer() {
      newCustomer.value.name = sanitizeName(newCustomer.value.name);

      const c = newCustomer.value;
      
      const rrnValue = (firstCivNum.value && lastCivNum.value) 
        ? `${firstCivNum.value}-${lastCivNum.value}` 
        : '';

      const sql = `INSERT INTO customers SET
        mb_id = '${member_info.mb_id}',
        name = '${escapeStr(c.name)}',
        nickname = ${c.nickname ? `'${escapeStr(c.nickname)}'` : 'NULL'},
        title = '고객님',
        rrn = ${rrnValue ? `'${escapeStr(rrnValue)}'` : 'NULL'},
        birth = ${c.birth ? `'${escapeStr(c.birth)}'` : 'NULL'},
        address = ${c.address ? `'${escapeStr(c.address)}'` : 'NULL'},
        ex_address = ${c.ex_address ? `'${escapeStr(c.ex_address)}'` : 'NULL'},
        location = ${c.location ? `'${escapeStr(c.location)}'` : 'NULL'},
        phone = ${c.phone ? `'${escapeStr(c.phone)}'` : 'NULL'}`;
      
        // 등록 성공 후 자동으로 마일스톤 체크
      checkCustomerMilestone(member_info.mb_id);

      const result = await sql_query(sql);
      const newCustomerIdx = result.insertId;

      // 새로 등록된 고객 정보를 불러와서 customer에 저장
      const customerSql = `SELECT * FROM customers WHERE idx = ${newCustomerIdx}`;
      const customerResult = await sql_query(customerSql);
      customer.value = customerResult[0];

      window.dispatchEvent(new CustomEvent('customer-updated'));

      setTimeout(() => {
        if (props.reloadForSync) {
          props.reloadForSync();
        }
      }, 200);

      return customer.value;
    }

    async function saveAndEdit() {
      if (isSaving.value) return;
      isSaving.value = true;
      
      try {
        const savedCustomer = await saveCustomer();
        
        // 부모에게 편집 모드로 전환 요청 (고객 정보와 함께)
        emit('openEdit', savedCustomer);
        
        // 현재 다이얼로그 닫기
        if (props.registerDialogSwitch) {
          props.registerDialogSwitch(false);
        }
        emit('close');
      } finally {
        isSaving.value = false;
      }
    }

    async function saveAndClose() {
      if (isSaving.value) return;
      isSaving.value = true;
      
      try {
        await saveCustomer();
        closeDialog();
      } finally {
        isSaving.value = false;
      }
    }

    function openDaumPostcode() {
      new window.daum.Postcode({
        oncomplete: function(data) {
          newCustomer.value.address = data.address + ' ' + data.buildingName;
          newCustomer.value.location = data.sido + ' ' + data.sigungu;
        }
      }).open();
    }

    function closeDialog() {
      if (props.registerDialogSwitch) {
        props.registerDialogSwitch(false);
      }
      emit('close');
    }

    function tagEditSwitch(value) {
      tag_edit_show.value = value;
    }

    function reloadTagList() {
      if (props.reloadForSync) {
        props.reloadForSync();
      }
    }

    function customerPickerSwitch(show) {
      showCustomerPicker.value = show;
    }

    function handleCustomerPickerSubmit(sel_customer) {
      console.log(sel_customer);
      customerPickerSwitch(false);
    }

    function handleDateSubmit({ year, month, day }) {
      const mm = String(month).padStart(2, '0');
      const dd = String(day).padStart(2, '0');
      const dateStr = `${year}-${mm}-${dd}`;
      console.log(dateStr);
      datePickerShow.value = false;
    }

    function reloadAll() {
      if (props.reloadForSync) {
        props.reloadForSync();
      }
    }

    return {
      swiperInstance,
      currentStep,
      totalSteps,
      modules,
      newCustomer,
      firstCivNum,
      lastCivNum,
      showCustomerPicker,
      datePickerShow,
      tempDateForWheel,
      tag_edit_show,
      customer,
      civNumLastInput,
      exAddressInput,
      isSaving,
      onSwiper,
      handleNext,
      nextStep,
      prevStep,
      saveCustomer,
      saveAndEdit,
      saveAndClose,
      closeDialog,
      tagEditSwitch,
      reloadTagList,
      customerPickerSwitch,
      handleCustomerPickerSubmit,
      handleDateSubmit,
      formatPhone,
      formatCivNum,
      focusLastCivNum,
      focusExAddress,
      reloadAll,
      openDaumPostcode,
      showNickname,
      showRealBirth,
      formatBirth,
      showExAddress
    };
  }
}
</script>

<style scoped>
#dialog-customerRegister {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-surface);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999999;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.dialog {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: var(--z-index-head);
  backdrop-filter: blur(var(--blur));
}

.cls {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.paper {
  position: relative;
  width: 90%;
  max-width: 500px;
  height: 85%;
  max-height: 800px;
  background: var(--color-background);
  border-radius: var(--radius-lg);
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-md);
  animation: slideUp 0.3s ease-out;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 28px;
  border-bottom: 1px solid var(--color-background-light);
}

.step-indicator {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-brand);
  background: var(--color-brand-light);
  padding: 8px 16px;
  border-radius: var(--radius-lg);
}

.header span {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: var(--font-size-xl);
  color: var(--color-text-secondary);
  transition: all 0.2s;
  border-radius: var(--radius-md);
}

.header span:hover {
  color: var(--color-text-primary);
  background: var(--color-background-light);
}

.register-swiper {
  flex: 1;
  width: 100%;
  overflow: hidden;
}

.step-content-single {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 32px;
  box-sizing: border-box;
  gap: 24px;
  text-align: center;
}

.icon {
  font-size: var(--font-size-5xl);
  animation: bounceIn 0.6s ease-out;
  filter: drop-shadow(var(--shadow-sm));
}

 .icon > img {
  width: 140px;
  height: 140px;
  object-fit: cover;
 }

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.icon.success {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, var(--color-special-point), #45b049);
  color: var(--color-text-white);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-4xl);
  box-shadow: var(--shadow-md);
}

h1 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-text-primary);
  margin: 0;
  letter-spacing: -0.8px;
  line-height: 1.3;
}

.desc {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  margin: -12px 0 0 0;
  line-height: 1.5;
}

.main-input {
  width: 100%;
  padding: 18px 20px;
  box-sizing: border-box;
  border: 2px solid var(--color-background-light);
  border-radius: var(--radius-md);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  background: var(--color-background);
  color: var(--color-text-primary);
  transition: all 0.3s;
  text-align: center;
}

.double {
  width: 100%;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
}

.main-input:focus {
  outline: none;
  border-color: var(--color-brand);
  box-shadow: 0 0 0 4px var(--color-brand-light);
  transform: scale(1.02);
}

.main-input::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
  font-weight: var(--font-weight-medium);
}

.find-btn {
  padding: 18px 24px;
  background: var(--color-brand);
  color: var(--color-text-black);
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.find-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.step-content-single.completion {
  gap: 32px;
}

.summary {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px;
  background: var(--color-background-light);
  border-radius: var(--radius-lg);
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid var(--color-surface-reverse);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
}

.summary-item:last-child {
  border-bottom: none;
}

.summary-item i {
  font-size: var(--font-size-xl);
  color: var(--color-brand);
}

.action-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 16px;
  border: 2px solid var(--color-brand);
  border-radius: var(--radius-lg);
  color: var(--color-brand);
  background: none;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn:hover {
  background: var(--color-brand);
  color: var(--color-text-black);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.action-btn.primary {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.action-btn.primary:hover {
  opacity: 0.9;
}

.action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.action-btn:disabled:hover {
  transform: none;
  box-shadow: none;
  background: none;
  color: var(--color-brand);
}

.action-btn.primary:disabled:hover {
  background: var(--color-brand);
  color: var(--color-text-black);
}

.nav-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 20px 28px;
  border-top: 1px solid var(--color-background-light);
}

.nav-btn {
  width: 56px;
  height: 56px;
  border: none;
  border-radius: 50%;
  background: var(--color-background-light);
  color: var(--color-text-primary);
  font-size: var(--font-size-xl);
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--shadow-sm);
}

.nav-btn:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-md);
}

.nav-btn.next.primary,
.nav-btn.complete {
  background: var(--color-brand);
  color: var(--color-text-black);
  box-shadow: var(--shadow-md);
}

.nav-btn.close {
  background: var(--color-special-point);
  color: var(--color-text-white);
  box-shadow: var(--shadow-md);
}

/* 옵션 필드 스타일 */
.optional-field {
  width: 100%;
  margin-top: 8px;
}

.toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: transparent;
  border: 1px dashed var(--color-text-secondary);
  border-radius: var(--radius-md);
  color: var(--color-text-secondary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all 0.2s;
}

.toggle-btn:hover {
  border-color: var(--color-brand);
  color: var(--color-brand);
  background: var(--color-brand-light);
}

.optional-input-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 6px;
  box-sizing: border-box;
  background: var(--color-background-light);
  border-radius: var(--radius-md);
  animation: fadeSlideIn 0.3s ease-out;
}


.optional-input-wrap label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-brand);
  text-align: left;
}

.sub-input {
  width: 100%;
  padding: 14px 16px;
  box-sizing: border-box;
  border: 1px solid var(--color-background-light);
  border-radius: var(--radius-md);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  background: var(--color-background);
  color: var(--color-text-primary);
  transition: all 0.2s;
  text-align: center;
}

.sub-input:focus {
  outline: none;
  border-color: var(--color-brand);
  box-shadow: 0 0 0 3px var(--color-brand-light);
}

.helper-text {
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  text-align: center;
}

@keyframes fadeSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 태블릿 (768px ~ 1024px) */
@media (min-width: 601px) and (max-width: 1024px) {
  .paper {
    width: 85%;
    max-width: 600px;
    height: auto;
    max-height: 90%;
    border-radius: var(--radius-lg);
  }

  .header {
    padding: 20px 32px;
  }

  .step-content-single {
    padding: 48px 64px;
    min-height: 400px;
  }

  .icon > img {
    width: 120px;
    height: 120px;
  }

  h1 {
    font-size: var(--font-size-2xl);
  }

  .main-input {
    max-width: 400px;
    padding: 16px 20px;
  }

  .double {
    max-width: 400px;
  }

  /* 완료 화면 summary 2컬럼 */
  .summary {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 16px;
    padding: 20px;
  }

  .summary-item {
    padding: 10px 0;
  }

  /* 주소처럼 긴 항목은 전체 너비 */
  .summary-item:has(.ph-house) {
    grid-column: span 2;
  }

  /* 완료 화면 버튼 가로 배치 */
  .step-content-single.completion .double {
    max-width: 100%;
    gap: 16px;
  }

  .action-btn {
    flex: 1;
    padding: 14px 20px;
  }

  /* 네비게이션 버튼 */
  .nav-buttons {
    padding: 16px 32px;
    justify-content: flex-end;
    gap: 12px;
  }

  .nav-btn {
    width: 52px;
    height: 52px;
  }
}

/* 모바일 (600px 이하) */
@media (max-width: 600px) {
  .paper {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    border-radius: 0;
  }

  .step-content-single {
    padding: 32px 24px;
  }

  .icon > img {
    width: 100px;
    height: 100px;
  }

  h1 {
    font-size: var(--font-size-xl);
  }

  .main-input {
    padding: 14px 16px;
    font-size: var(--font-size-md);
  }

  .summary {
    padding: 16px;
  }

  .summary-item {
    padding: 8px 0;
    font-size: var(--font-size-sm);
  }

  /* 완료 화면 버튼 세로 배치 */
  .step-content-single.completion .double {
    flex-direction: column;
  }

  .nav-btn {
    width: 48px;
    height: 48px;
  }
}
</style>